module.exports = __webpack_public_path__ + "static/media/sweet2.44253082.png";